import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { SPOTS_FILLED_PERCENT, SPOTS_LEFT } from '../../data/offer';
export function ScarcityBar() {
  const reduce = useReducedMotion();
  return <div className="w-full" data-id="element-388" data-mp="2xwk6a8yws85y">
      <div className="flex items-center justify-between gap-2 text-sm font-bold text-heading" data-id="element-389" data-mp="2sztsjsaktonp">
        <span className="flex items-center gap-1.5" data-id="element-390" data-mp="37wuhxp5ap7j0">
          <FlameIcon className="h-4 w-4 text-danger" aria-hidden="true" data-id="element-391" data-mp="37v9s2ctxecrh" />
          Only {SPOTS_LEFT} spots left at the promotional price
        </span>
        <span className="shrink-0 text-danger" data-id="element-392" data-mp="3gowiroja0ptt">{SPOTS_FILLED_PERCENT}%</span>
      </div>
      <div className="mt-2 h-3.5 w-full overflow-hidden rounded-full bg-line" role="progressbar" aria-valuenow={SPOTS_FILLED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-393" data-mp="3cnj9t5kw06io">
        <motion.div className="h-full rounded-full bg-danger" initial={{
        width: reduce ? `${SPOTS_FILLED_PERCENT}%` : '40%'
      }} whileInView={{
        width: `${SPOTS_FILLED_PERCENT}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-394" data-mp="3lq2bhmcxsd3c" />
      </div>
    </div>;
}